function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M3.075 20c-.42 0-.788-.16-1.103-.48A1.547 1.547 0 011.5 18.4V5.6c0-.427.157-.8.472-1.12.316-.32.683-.48 1.103-.48h17.85c.42 0 .787.16 1.102.48.316.32.473.693.473 1.12v12.8c0 .427-.157.8-.473 1.12-.315.32-.682.48-1.102.48H3.075zm0-1.6h17.85V5.6H3.075v12.8zm2.415-2.853h6.274v-.374c0-.32-.079-.604-.236-.853a1.19 1.19 0 00-.604-.507c-.56-.195-.998-.324-1.313-.386a4.73 4.73 0 00-.918-.094c-.333 0-.687.04-1.064.12-.376.08-.8.2-1.273.36a1.18 1.18 0 00-.63.507 1.562 1.562 0 00-.236.853v.374zm8.82-1.787h4.463v-1.333H14.31v1.333zm-5.617-1.333c.393 0 .728-.14 1.004-.42a1.4 1.4 0 00.413-1.02c0-.4-.138-.74-.413-1.02-.276-.28-.61-.42-1.004-.42s-.729.14-1.005.42a1.4 1.4 0 00-.413 1.02c0 .4.138.74.413 1.02.276.28.61.42 1.005.42zm5.617-1.68h4.463V9.413H14.31v1.334z"
  }));
};
const SvgLicense = styled(BaseComponent).withConfig({
  displayName: "License__SvgLicense",
  componentId: "sc-diq1x3-0"
})(["outline:none;"]);
SvgLicense.isIcon = true;
SvgLicense.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgLicense;